<template>
  <div class="flex relative pt-8">
    <header class="flex items-center bg-white px-8">
      <h2 class="font-semibold">{{ APPEARANCE_STRINGS.title }}</h2>
    </header>
    <div class="pr-8 absolute right-0">
      <busy-button :id="BUSY_BUTTONS.APPEARANCE_SAVE"
                   icon-size="1.2rem"
                   :variant="variant"
                   class="w-44"
                   :disabled="isSaveDisabled"
                   :is-loading="isSaveBusy"
                   @click="$emit('save-theme')"
      >
        {{ text }}
      </busy-button>
    </div>
  </div>

</template>

<script>
import BusyButton from '@/components/common/BusyButton.vue'
import busyButtonsModule from '@/store/modules/busy-buttons.module'
import isEmpty from 'ramda/src/isEmpty'
import isNil from 'ramda/src/isNil'
import { APPEARANCE_STRINGS } from '@/constants/chat-theme.constants'
import { BUSY_BUTTONS } from '@/utils/busy-buttons.constants'

export default {
  name: 'SettingsBotThemeHeader',

  components: { BusyButton },

  props: {
    isJsonInvalid: {
      type: Boolean,
      required: true
    },
    variant: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },

  emits: ['save-theme'],

  data() {
    return {
      BUSY_BUTTONS,
      APPEARANCE_STRINGS
    }
  },

  computed: {
    isSaveDisabled() {
      if (isNil(this.selectedTheme)) return true
      const isNameEmpty = isEmpty(this.selectedTheme.name?.trim())
      return isNameEmpty || this.isJsonInvalid
    },

    isSaveBusy() {
      return !!busyButtonsModule.isButtonBusy(BUSY_BUTTONS.APPEARANCE_SAVE)
    }
  }
}
</script>
